export var translations = {
  pt: {
    // General
    subtitle: "Análise avançada de performance para radioamadores. Contest - DX - FT8",
    loading: "Carregando...",
    errConnection: "Erro de conexão",
    confirm: "Confirmar",
    tip: "Dica",

    // Nav
    home: "Home", dashboard: "Dashboard", map: "Mapa", charts: "Gráficos",
    rankings: "Rankings", dxIntel: "IA Report", log: "Log", support: "Apoie",
    dxccNav: "DXCC",
    community: "Comunidade", profile: "Perfil", contests: "Contests", contestsNav: "Contest/Ativação",
    uploadLogs: "Upload Logs",
    logout: "Sair",

    // Bug reports / tickets
    bugReport: "Reportar Bug",
    integrations: "Integrações",
    integrationsTitle: "Integrações",
    integrationsSubtitle: "Conecte o HamExpert às suas ferramentas: LoTW, MSHV / WSJT-X e QRZ.com.",
    subscription: "Assinatura",
    subTitle: "Escolha seu plano",
    subSubtitle: "Comece grátis. Faça upgrade para o Premium quando quiser desbloquear as integrações.",
    subLaunchBanner: "🎉 Lançamento: o Premium está liberado para todos gratuitamente por tempo limitado.",
    subCurrentPlan: "Seu plano atual",
    subCompareCol: "Compare os planos",
    subPlanFreeName: "Free",
    subPlanFreePrice: "Grátis",
    subPlanFreeTag: "Para sempre",
    subPlanFreeDesc: "Todos os módulos de análise do seu log.",
    subPlanPremiumName: "Premium",
    subPlanPremiumPrice: "R$ 6",
    subPlanPremiumPeriod: "/mês",
    subPlanPremiumTag: "Pagamento recorrente no cartão",
    subPlanPremiumDesc: "Tudo do Free + integrações completas.",
    subFeatAllModules: "Todos os módulos (Dashboard, Gráficos, DXCC, Rankings, Log, QSL Cards, Field Ops…)",
    subFeatCommunity: "Comunidade e Live Streams",
    subFeatIaReport: "IA Report: análise inteligente dos seus logs com IA + assistente pessoal para dúvidas",
    subFeatIntegrations: "Integrações: LoTW, MSHV / WSJT-X, Log4OM / UDP",
    subFeatQrzDash: "Dashboard incorporável no perfil QRZ.com",
    subFeatPrioritySupport: "Suporte prioritário",
    subFeatNoIntegrations: "Sem integrações: LoTW, MSHV / WSJT-X, Log4OM / UDP",
    subFeatNoIaReport: "Sem o módulo de IA Report",
    subFeatNoQrzDash: "Sem dashboard QRZ.com",
    subBtnCurrent: "Plano atual",
    subBtnSubscribe: "Assinar Premium",
    subBtnActiveLaunch: "✓ Premium ativo (lançamento)",
    subRecurringNote: "Cobrança mensal de R$ 6,00 no cartão de crédito. Cancele quando quiser.",
    subIncluded: "Incluído",
    subNotIncluded: "Não incluído",
    premiumLockTitle: "Recurso Premium",
    premiumLockDesc: "As integrações fazem parte do plano Premium. Faça upgrade para conectar LoTW, MSHV / WSJT-X, Log4OM e o dashboard do QRZ.com.",
    premiumLockBtn: "Ver planos",
    log4omTab: "Log4OM / UDP",
    intHistoryTitle: "Histórico (24h)",
    intHistoryTab: "Histórico",
    intHistoryDesc: "Atividade de sincronização de todas as integrações nas últimas 24h.",
    refresh: "Atualizar",
    intHistoryEmpty: "Nenhuma atividade nas últimas 24h",
    intHistColWhen: "Quando",
    intHistColSource: "Origem",
    intHistColLoaded: "Carregados",
    intHistColStatus: "Status",
    intHistOk: "OK",
    intHistError: "Erro",
    udpTitle: "Recebimento UDP",
    udpDesc: "Serviço do servidor para receber QSOs de softwares como Log4OM, N1MM e GridTracker via UDP (encaminhamento ADIF).",
    udpRunning: "Servidor Rodando",
    udpStopped: "Servidor Parado",
    udpManagedByAdmin: "Gerenciado pelo Admin",
    udpConnAddress: "Endereço de Conexão",
    udpTip: "Configure seu software para encaminhar QSOs em ADIF para este endereço. Os contatos são atribuídos automaticamente ao seu indicativo (campo STATION_CALLSIGN).",
    profileTitle: "Meu Perfil",
    profileSubtitle: "Configure seu perfil de radioamador",
    ptabInfo: "Informações",
    ptabStation: "Estação",
    ptabLinks: "Links",
    ptabImages: "Imagens",
    ptabAccount: "Conta",
    personalInfo: "Informações Pessoais",
    profilePhotoTitle: "Foto de Perfil",
    profilePhotoHint: "Clique na câmera para alterar",
    nameLabel: "Nome",
    callsignField: "Indicativo",
    countryLabel: "País",
    qthLabel: "QTH",
    saveProfile: "Salvar Perfil",
    stationTitle: "Equipamento e Estação",
    linksTitle: "Links e Redes Sociais",
    imagesTitle: "Imagem de Perfil",
    livestreams: "Live Streams",
    livestreamsTitle: "Live Streams Ativos",
    livestreamsSubtitle: "Estações de DX transmitindo ao vivo agora — cace os contatos importantes.",
    livestreamsSearch: "Buscar indicativo/país",
    livestreamsSortRank: "Por Ranking DXCC",
    livestreamsSortTime: "Por Horário",
    livestreamsLoading: "Carregando live streams...",
    livestreamsEmpty: "Nenhum stream ativo no momento",
    livestreamsColCall: "Indicativo",
    livestreamsColLocation: "Localização",
    livestreamsColRank: "Rank",
    livestreamsColLast: "Último QSO",
    livestreamsColWatchers: "Assistindo",
    livestreamsWatch: "Assistir",
    livestreamsCredit: "Dados fornecidos por Club Log (clublog.org). Atualiza automaticamente a cada 30s.",
    bugReportTitle: "Reportar Bug",
    bugReportSubtitle: "Encontrou um problema? Abra um ticket e nos ajude a melhorar o HamExpert.",
    newTicket: "Novo Ticket",
    noTickets: "Nenhum ticket",
    noTicketsHint: "Você ainda não reportou nenhum erro. Clique em \u201cNovo Ticket\u201d para começar.",
    colMenu: "Menu",
    colTab: "Aba",
    colDescription: "Descrição",
    colStatus: "Status",
    colActions: "Ações",
    colDate: "Data",
    ticketMenu: "Menu",
    ticketTab: "Aba",
    ticketMenuPlaceholder: "Ex: Dashboard, Rankings, QSL Cards…",
    ticketTabPlaceholder: "Ex: Mapa de Contatos (opcional)",
    ticketDescription: "Descrição do problema",
    ticketDescriptionPlaceholder: "Descreva o que aconteceu, o que você esperava e como reproduzir…",
    sendTicket: "Enviar Ticket",
    cancel: "Cancelar",
    ticketSent: "Ticket enviado com sucesso!",
    ticketError: "Erro ao enviar o ticket.",
    descRequired: "Por favor, descreva o problema.",
    deleteTicketConfirm: "Remover este ticket?",
    statusOpen: "Aberto",
    statusInProgress: "Em andamento",
    statusResolved: "Resolvido",
    statusClosed: "Fechado",
    attachScreenshot: "Anexar print (opcional)",
    addImage: "Adicionar imagem",
    removeImage: "Remover",
    viewScreenshot: "Ver print",
    imageInvalid: "Selecione um arquivo de imagem.",
    imageTooBig: "Imagem muito grande (máx. 6MB).",
    colImage: "Print",
    // Bug report v1.0.5
    ticketType: "Tipo",
    ticketTypeBug: "Bug",
    ticketTypeSuggestion: "Sugestão",
    ticketTypeQuestion: "Dúvida",
    ticketSeverity: "Severidade",
    sevLow: "Baixa",
    sevMedium: "Média",
    sevHigh: "Alta",
    sevCritical: "Crítica",
    ticketWhatHappened: "O que aconteceu?",
    ticketWhatHappenedPh: "Descreva o problema que você encontrou…",
    ticketExpected: "O que você esperava?",
    ticketExpectedPh: "O que deveria ter acontecido (opcional)…",
    ticketSteps: "Passos para reproduzir",
    ticketStepsPh: "1. Abri… 2. Cliquei… 3. Aconteceu… (opcional)",
    ticketContext: "Contexto capturado automaticamente",
    ticketContextPage: "Página",
    ticketContextVersion: "Versão",
    ticketContextDevice: "Dispositivo",
    attachScreenshots: "Anexar prints (até 5)",
    colType: "Tipo",
    filterAll: "Todos",
    ticketDetail: "Detalhes do ticket",
    ticketConversation: "Conversa",
    ticketNoReplies: "Sem mensagens ainda. Escreva abaixo para falar com a equipe.",
    ticketReplyPh: "Escreva uma mensagem…",
    ticketSendReply: "Enviar",
    ticketReplyEmpty: "Escreva uma mensagem.",
    ticketYou: "Você",
    ticketTeam: "Equipe HamExpert",
    ticketNewUpdate: "Nova resposta da equipe",
    ticketBack: "Voltar",
    ticketOpenDetail: "Abrir",

    // Auth
    login: "Entrar",
    createAccount: "Criar Conta",
    backToLogin: "Voltar ao login",
    recoverPassword: "Recuperar Senha",
    recoverPasswordDesc: "Enviaremos um link para o e-mail cadastrado",
    passwordLabel: "SENHA",
    confirmPasswordLabel: "CONFIRMAR SENHA",
    yourCallsign: "SEU INDICATIVO",
    verifying: "Verificando...",
    creatingAccount: "Criando conta...",
    sending: "Enviando...",
    sendRecoveryLink: "Enviar Link de Recuperação",
    forgotPassword: "Esqueci minha senha",
    loginIntro: "Analise seus QSOs com inteligência. Estatísticas, mapas, DX e muito mais.",
    callsignPh: "Ex: PP5GP",
    yourPassword: "Sua senha",
    minChars: "Mínimo 8 caracteres",
    repeatPassword: "Repita a senha",
    yourCallsignPh: "Seu indicativo",
    yourEmail: "seu@email.com",

    // Auth errors
    errFillCallPass: "Preencha callsign e senha.",
    errFillAll: "Preencha todos os campos.",
    errPassMismatch: "Senhas não conferem.",
    errPassMin: "Senha mínima: 8 caracteres.",
    accountCreated: "Conta criada! Faça login, ",
    errFillAllFields: "Preencha todos os campos.",
    errPassMismatchShort: "Senhas não conferem.",
    errPassMin8: "Mínimo 8 caracteres.",
    passChanged: "Senha alterada com sucesso!",
    errChangePass: "Erro ao alterar senha",

    // Login features
    featureStats: "IA Inteligente",
    featureStatsSub: "Estatísticas com IA que aprende com o seu log",
    featureMap: "Dashboard QRZ",
    featureMapSub: "Incorpore no QRZ e compartilhe sua performance",
    featureIncremental: "SOTA, POTA & Contests",
    featureIncrementalSub: "Upload incremental com sync via LoTW",
    developedBy: "Desenvolvido por",

    // Upload / Home
    dragHere: "Arraste seu log aqui",
    orClick: "ou clique para selecionar",
    myGrid: "Meu Grid:",
    detectedAuto: "Detectado automaticamente:",
    processing: "Processando log...",
    qsosLoaded: "QSOs carregados!",
    whatToDo: "O que deseja fazer?",
    logBook: "Livro de Log",
    logBookDesc: "Suba seu ADIF para o livro de logs. Upload incremental — apenas QSOs novos.",
    contestEvent: "Contest / Evento",
    contestEventDesc: "Análise isolada de contest, Field Day, ativações especiais.",
    contestNameLabel: "Nome:",
    contestNamePh: "Ex: CQ WPX 2026, Field Day",
    contestNameRequired: "Informe o nome do contest/evento antes de subir o log",
    loadingServerQsos: "Carregando QSOs salvos do servidor...",
    formatNotRecognized: "Formato não reconhecido. Use ADIF ou Cabrillo.",
    noQsoFound: "Nenhum QSO encontrado.",
    savedOnServer: "QSOs salvos no servidor",
    dupsRemoved: "dups removidos",

    // Dashboard
    totalQsos: "Total QSOs", uniqueCalls: "Calls Únicos", countriesDxcc: "Países DXCC",
    uniqueGrids: "Grids Únicos", maxDistance: "Maior Distância", avgDistance: "Distância Média",
    logPeriod: "Período do Log", qsoPerHour: "QSO/Hora Média", bestHour: "Melhor Hora",
    bestBand: "Melhor Banda", topBandDay: "Top Banda Dia", topBandNight: "Top Banda Noite",
    days: "dias", daysOfLog: "dias de log", qsosInBestBand: "QSOs na melhor banda",
    qsosByHourUtc: "Média de QSOs por Hora", qsosByBand: "QSOs por Banda", qsosByMode: "QSOs por Modo",
    qsosByContinent: "QSOs por Continente", detailedByBand: "Média de QSOs por Hora - Detalhado por Banda",
    allBands: "Todas", top10Countries: "Top 10 Países DXCC",
    dateAll: "Tudo",
    dateTo: "a",
    mediaPerDay: "Média",
    qsosPerDay: "QSOs/dia",
    totalLabel: "Total",
    daysLabel: "dias",

    // Map
    withGrid: "Com Grid", withoutGrid: "Sem Grid", countries: "Países", fullMap: "Mapa Completo",
    mapTitle: "Mapa de QSOs", mapGridTitle: "Mapa de Grids Contatados", qsosWithCoords: "QSOs com coordenadas",
    mapLabel: "Mapa",
    // DXCC Tracker
    dxAwardsNav: "Premiações DX",
    dxccTitle: "DXCC Tracker", dxccWorked: "Trabalhados", dxccConfirmed: "Confirmados", dxccNeeded: "Faltando",
    dxccByBand: "Por Banda", dxccByMode: "Por Modo", dxccAll: "Todos", dxccFilterCont: "Continente",
    dxccEntity: "Entidade", dxccTotal: "Total",
    // WAC / WAZ
    wacTitle: "WAC - Todos Continentes", wazTitle: "WAZ - Todas Zonas CQ",
    zonesWorked: "zonas trabalhadas", zonesConfirmed: "confirmadas",
    // New One Alerts
    newDxcc: "Novo DXCC!", newBandSlot: "Nova Banda!", newGrid: "Novo Grid!", showNewOnly: "Apenas novos", newOneAlerts: "Alertas New One",
    // Heraldo
    heraldoPlaceholder: "Pergunte algo sobre r\u00e1dio...", heraldoError: "Erro ao conectar com Heraldo. Tente novamente.",
    // Callsign Lookup
    callsignLookup: "Callsign Lookup", searchAll: "Buscar", notFound: "N\u00e3o encontrado", notInFcc: "N\u00e3o encontrado no FCC",

    // Charts
    chartsTitle: "Gráficos Interativos",
    qsoRateByHour: "Taxa de QSO por Hora", qsosOverTime: "QSOs ao Longo do Tempo",
    distributionByMode: "Distribuição por Modo",

    // Rankings
    rankingsTitle: "Rankings e Estatísticas",
    rankingDxcc: "Ranking DXCC - Países", rankingBands: "Ranking Bandas",
    rankingModes: "Ranking Modos", rankingContinents: "Ranking Continentes",
    rankingHours: "Ranking Horas", rankingCqZones: "Ranking Zonas CQ",

    // IA Report
    dxIntelTitle: "IA Report",
    recommendations: "Recomendações Baseadas nos Seus Logs",
    activityByBand: "Média de Atividade por Banda x Hora (24h)",
    bestBandByPeriod: "Melhor Banda por Período (3h)",
    periodUtc: "Período", firstBand: "1ª Banda", secondBand: "2ª Banda",
    avgDistByBand: "Distância Média por Banda", topContinentsByBand: "Top Continentes por Banda",
    dayOperation: "Operação Diurna",
    nightOperation: "Operação Noturna",
    confLabel: "Conf.",
    confInsufficient: "Dados insuficientes",
    confLow: "Confiança baixa",
    confMedium: "Confiança média",
    confHigh: "Alta confiança",
    confInfo: "Info",

    // DX Intel recommendations
    recBestTime: "Seu melhor horário é {slot} com {total} QSOs. Concentre a operação neste período.",
    recBestDist: "Banda {band} tem a maior distância média ({dist} km). Ideal para DX longo.",
    recDayNight: "De dia use {day}, de noite mude para {night} para maximizar QSOs.",
    recNightWindow: "Melhor janela noturna: {slot} ({band} com {qsos} QSOs).",

    // Log page
    logTitle: "Log",
    filterPlaceholder: "Filtrar call, país, banda, modo...",
    showing: "Mostrando", of: "de",
    exportAdif: "Exportar ADIF", exportAll: "Exportar Todos",
    allBandsFilter: "Todas bandas", allModesFilter: "Todos modos", dateFromLabel: "De", dateToLabel: "Até",
    prevPage: "Anterior", nextPage: "Próxima", pageOf: "de",

    // Support / Coffee
    supportTitle: "Apoie o Projeto HamExpert", buyMeACoffee: "Buy Me a Coffee",
    coffeeText: "Se o HamExpert te ajudou a analisar seus logs e melhorar sua performance, considere me pagar um café! Cada contribuição ajuda a manter o projeto ativo.",
    whatYouSupport: "O que sua contribuição apoia",
    supportItems: ["Servidor e hospedagem","Novas funcionalidades","Base DXCC atualizada","Novos formatos de log","Melhorias IA Report","Café pro PP5GP nos contests!"],
    bioText: "Radioamador classe A (PP5GP), operando de Brusque, SC, Brasil. Apaixonado por eletrônica e fascinado pelo mundo da radiofrequência. Profissional de TI com mais de 15 anos de experiência em infraestrutura, automação, cloud computing e DevOps. Criador do HamExpert.",
    footer: "HamExpert v1.2.2 - hamexpert.cloud - Desenvolvido por PP5GP - Geraldo Lucas Poli - 73!",
    supportersTitle: "Apoiadores do Projeto",
    supportersFalcons: "Amigos acima de tudo",
    supportersFalconsDesc: "Grupo de amigos radioamadores que apoia e utiliza o HamExpert",

    // Contests
    myContests: "Meus Contests",
    contestSaved: "salvo",
    contestsSaved: "salvos",
    noContestSaved: "Nenhum contest salvo",
    noContestDesc: "Suba um log no modo Contest na tela inicial para analisar performance em contests isoladamente.",
    goToContestUpload: "Ir para Upload Contest",
    analyzePerformance: "Analisar Performance",
    fileLabel: "Arquivo",

    // Profile
    accountData: "Dados da Conta",
    totalLogins: "Total de Logins",
    memberSince: "Membro desde",
    changePassword: "Alterar Senha",
    currentPassword: "Senha atual",
    newPassword: "Nova senha",
    confirmNew: "Confirmar nova",
    saveNewPassword: "Salvar Nova Senha",
    publicProfile: "Meu Perfil Público",
    publicProfileDesc: "Configure seu perfil para ser encontrado pela comunidade.",
    loadProfile: "Carregar Perfil",
    fullName: "Nome completo",
    licenseClass: "Classe de licença",
    licenseClassPh: "Ex: Classe A",
    bioAbout: "Bio / Sobre mim",
    bioPlaceholder: "Conte sobre você e sua estação...",
    cityLabel: "Cidade",
    stateLabel: "Estado",
    statePh: "Ex: SC",
    gridLocator: "Grid Locator",
    gridLocatorPh: "Ex: GG54mc",
    equipmentLabel: "Equipamento",
    equipmentPh: "Ex: Yaesu FTDX10",
    antennaLabel: "Antena",
    antennaPh: "Ex: Hexbeam",
    powerLabel: "Potência",
    powerPh: "Ex: 100W",
    profilePhoto: "Foto de perfil",
    sendPhoto: "Enviar Foto",
    removePhoto: "Remover Foto",
    fileTooLarge: "Arquivo muito grande (max 5MB)",
    photoUpdated: "Foto atualizada com sucesso!",
    removeProfilePhotoConfirm: "Remover foto de perfil?",
    savePublicProfile: "Salvar Perfil Público",

    // LoTW
    lotwIntegration: "LoTW - Importar QSOs",
    lotwDesc: "Puxe seus QSOs confirmados do LoTW para o HamExpert. Apenas leitura — não envia dados ao LoTW.",
    checkLotwStatus: "Verificar Status LoTW",
    lotwLoginPh: "Login LoTW (callsign)",
    lotwPassPh: "Senha LoTW",
    fillLoginPass: "Preencha login e senha",
    saving: "Salvando...",
    saveLotwCred: "Salvar Credenciais LoTW",
    syncLabel: "Sync",
    active1h: "ATIVO (1h)",
    disabledLabel: "DESATIVADO",
    lastSync: "Último sync",
    never: "Nunca",
    qsosViaLotw: "QSOs via LoTW",
    errorLabel: "Erro",
    syncNow: "Sincronizar Agora",
    fullSync: "Re-sync Completo",
    fullSyncHint: "Reprocessa todo o histórico do LoTW para atualizar as entidades DXCC oficiais. Use se a contagem de países DXCC estiver diferente do LoTW.",
    fullSyncOk: "Re-sincronização completa concluída. Confirmados:",
    syncing: "Sincronizando...",
    disableSync: "Desativar Sync",
    enableSync: "Ativar Sync",
    removeLotwCredConfirm: "Remover credenciais LoTW?",
    removeLabel: "Remover",
    credRemoved: "Credenciais removidas",
    syncOk: "Sync OK!",
    newQsos: "novos QSOs",

    // QRZ Logbook import
    qrzImportTitle: "QRZ Logbook — Importar QSOs",
    qrzImportDesc: "Sincronize automaticamente o seu log do QRZ.com com o HamExpert pela API oficial do QRZ Logbook. Importação incremental: só traz QSOs novos, e marca como confirmados os QSOs já confirmados no QRZ.",
    qrzApiKeyPh: "Chave da API do Logbook (QRZ)",
    qrzApiKeyHint: "Encontre em QRZ.com → Logbook → Settings → \"API Access\". Requer assinatura XML do QRZ.",
    saveQrzKey: "Validar e Salvar Chave",
    qrzImportBtn: "Conectar e Importar do QRZ",
    qrzImporting: "Importando do QRZ...",
    onboardingOr: "ou",
    validating: "Validando...",
    qrzBook: "Logbook",
    qrzBookCount: "QSOs no QRZ",
    qsosViaQrz: "QSOs importados do QRZ",
    removeQrzKeyConfirm: "Remover a chave API do QRZ?",
    qrzKeyRemoved: "Chave QRZ removida",
    qrzKeySaved: "Chave validada e salva!",
    fillQrzKey: "Informe a chave da API do QRZ",
    qrzFullResync: "Reimportar tudo",
    qrzFullResyncConfirm: "Reimportar TODO o histórico do QRZ do zero? É seguro (não duplica), mas pode demorar se o log for grande.",

    // QRZ Embed
    qrzCode: "Código para o QRZ.com",
    qrzDesc: "Cole este código HTML na bio do seu perfil no QRZ.com para exibir suas estatísticas.",
    publicLink: "Link público",
    htmlCode: "Código HTML (iframe)",
    copyIframe: "Copiar Iframe",
    copied: "Copiado!",
    copyBadge: "Copiar Badge",
    qrzTip: "Se o QRZ não aceitar iframe, use o Badge que funciona em qualquer site.",

    // Session
    sessionLabel: "Sessão",
    logoutAccount: "Sair da Conta",

    // Community
    communityTitle: "Comunidade HamExpert",
    commTabOperators: "Operadores",
    commTabForum: "Fórum",
    delete: "Excluir",
    fcat_general: "Geral",
    fcat_dx: "DX & Expedições",
    fcat_equipment: "Equipamentos",
    fcat_contest: "Contests",
    fcat_help: "Ajuda",
    fcat_news: "Notícias",
    forumAll: "Todos",
    forumNewTopic: "Novo tópico",
    forumEmptyTitle: "Nenhum tópico ainda",
    forumEmptyDesc: "Seja o primeiro a iniciar uma conversa na comunidade.",
    forumRepliesShort: "respostas",
    forumReplies: "respostas",
    forumNoReplies: "Ainda não há respostas. Seja o primeiro a responder!",
    forumReplyPlaceholder: "Escreva sua resposta...",
    forumSendReply: "Responder",
    forumLoginToReply: "Entre na sua conta para participar da conversa.",
    forumBackToList: "Voltar aos tópicos",
    forumNotFound: "Tópico não encontrado.",
    forumCategory: "Categoria",
    forumTitleLabel: "Título",
    forumTitlePlaceholder: "Resuma o assunto do seu tópico",
    forumBodyLabel: "Mensagem",
    forumBodyPlaceholder: "Compartilhe sua dúvida, experiência ou novidade...",
    forumPublish: "Publicar",
    forumDeleteConfirm: "Excluir este tópico e todas as respostas?",
    docs: "Documentação",
    docsTitle: "Documentação",
    docsNewArticle: "Novo artigo",
    docsEditArticle: "Editar artigo",
    docsEmptyShort: "Nenhum artigo",
    docsEmptyTitle: "Nenhum artigo ainda",
    docsEmptyAdmin: "Crie o primeiro artigo clicando em \"Novo artigo\".",
    docsEmptyUser: "A documentação ainda está sendo preparada.",
    docsUpdated: "Atualizado",
    docsCategory: "Categoria",
    docsArticleTitle: "Título",
    docsContent: "Conteúdo",
    docsMarkdownHint: "(suporta markdown)",
    docsDeleteConfirm: "Excluir este artigo?",
    edit: "Editar",
    save: "Salvar",
    searchPlaceholder: "Buscar por indicativo, nome ou cidade...",
    searchBtn: "Buscar",
    noResults: "Nenhum resultado encontrado",
    loadMembers: "Carregar Membros da Comunidade",
    loadingMembers: "Carregando membros...",
    back: "Voltar",
    bandsLabel: "Bandas",
    stationLabel: "Estação",
    linksLabel: "Links",
    memberSinceLabel: "Membro desde",
    editProfile: "Editar perfil",
    classLabel: "Classe",
    kpiTotalQsos: "QSOs registrados",
    kpiUniqueCalls: "Indicativos",
    kpiGrids: "Grids",

    // Realtime
    realtime: "Realtime",
    realtimeTitle: "Propagação em Tempo Real",
    realtimeDesc: "Spots FT8/FT4 ao vivo via PSKReporter",
    bestBandNow: "Melhor Banda Agora",
    activeSpots: "Spots Ativos",
    activeBands: "Bandas Ativas",
    activeGrids: "Grids Ativos",
    lastUpdateRt: "Última Atualização",
    autoRefresh: "Auto Refresh",
    spotCount: "Spots",
    avgSnr: "SNR Médio",
    avgDistRt: "Dist. Média",
    recommendationRt: "Recomendação",
    bandScore: "Score",
    realtimeMap: "Mapa de Propagação",
    spotsTable: "Tabela de Spots",
    sender: "Emissor",
    receiver: "Receptor",
    frequencyRt: "Frequência",
    noSpotsYet: "Aguardando spots do PSKReporter... Atualização a cada 5 minutos.",
    bestBandExplain: "Com base nos spots dos últimos 15 min, {band} em {mode} tem a melhor propagação agora para a sua localização.",
    allModes: "Todos",
    filterBand: "Filtrar Banda",
    filterMode: "Filtrar Modo",
    minSnr: "SNR mín.",
    allSnr: "Todos",
    totalCached: "Total em Cache",
    snrLabel: "SNR",
    distLabel: "Distância",
    timeLabel: "Hora",
    bandActivity: "Atividade por Banda",
    refreshNow: "Atualizar Agora",
    propagationScore: "Score de Propagação",
    spotsLast15: "spots nos últimos 15 min",
    bestForDx: "Melhor para DX",
    bestForRegional: "Melhor para Regional",
    noBandData: "Sem dados de banda ainda",

    // AI Analysis
    aiAnalysis: "Análise com IA",
    aiGenerateBtn: "Gerar Análise com IA",
    aiGenerating: "Analisando seus dados com IA...",
    aiPoweredBy: "Análise gerada por IA",
    aiCached: "Análise em cache (atualiza a cada 5 min)",
    aiError: "Erro ao gerar análise. Tente novamente.",
    aiTitle: "Análise Inteligente do Seu Log",
    saveEmail: "Salvar Email",
    emailUpdated: "Email atualizado com sucesso!",
    errInvalidEmail: "Email inválido. Use um email real (ex: nome@gmail.com).",
    bioHtmlTip: "Suporta HTML: <h2>, <b>, <img src=\"...\">, <a href=\"...\">, <p>, <ul>, <li>, <blockquote>",
    topOperators: "Top Operadores HamExpert",
    realtimeUpload: "Upload em Tempo Real (MSHV / WSJT-X)",
    realtimeUploadDesc: "Receba QSOs automaticamente do MSHV, WSJT-X ou qualquer software que suporte upload via HTTP/ADIF.",
    generateApiKey: "Gerar Chave de API",
    mshvConfig: "Configuração MSHV / WSJT-X",
    mshvInstructions: "No MSHV: Configurações da Rede > Upload dos QSOs em Tempo Real. Cole o servidor e o post acima. Cada QSO feito será enviado automaticamente para o HamExpert.",

    // Register Log / Manual QSO
    registerLog: "Registrar Log",
    manualQso: "Registro Manual de QSO",
    manualQsoDesc: "Registre um QSO manualmente preenchendo os campos abaixo.",
    callsignLabel: "Callsign",
    dateLabel: "Data",
    timeUtcLabel: "Hora UTC",
    nowBtn: "Agora",
    bandLabel: "Banda",
    modeLabel: "Modo",
    rstSentLabel: "RST Enviado",
    rstRcvdLabel: "RST Recebido",
    freqLabel: "Frequência",
    powerLabelQso: "Potência",
    gridLabel: "Grid",
    notesLabel: "Notas",
    commentsLabel: "Comentários",
    moreDetails: "+ Detalhes",
    lessDetails: "- Detalhes",
    saveQso: "Salvar QSO",
    savingQso: "Salvando...",
    qsoSaved: "QSO salvo com sucesso!",
    qsoSaveError: "Erro ao salvar QSO",
    fillCallsign: "Preencha o indicativo",
    uploadFile: "Upload de Arquivo",
    uploadFileDesc: "Suba seu arquivo ADIF ou Cabrillo para o livro de logs ou contest.",

    // Field Ops - Weather & Propagation
    fieldops: "Field Ops",
    fieldopsTitle: "Clima & Propagação",
    solarPropagation: "Propagação Solar",
    solarFlux: "Fluxo Solar (SFI)",
    aIndex: "Índice A",
    kIndex: "Índice K",
    sunspots: "Manchas Solares",
    signalNoise: "Ruído",
    geomagField: "Campo Geomagnético",
    bandConditions: "Condições das Bandas",
    bandDay: "Dia",
    bandNight: "Noite",
    fieldOpsWeather: "Clima & Segurança de Operação em Campo",
    fieldOpsDesc: "Condições climáticas locais para operação portátil e em campo.",
    fieldopsLocation: "Localização da operação",
    fieldopsLocHint: "Escolha onde você vai operar (POTA/SOTA/Field Day): clique ou arraste o pino, digite o grid ou busque a cidade.",
    searchCity: "Buscar cidade...",
    enterGrid: "Grid (ex: GI06)",
    useMyQth: "Meu QTH",
    changeLocation: "Alterar",
    closeLocation: "Fechar",
    useGps: "GPS",
    useGpsHint: "Usar minha posição",
    gpsError: "Não foi possível obter sua posição",
    localBandConditions: "Condições de banda no seu local",
    bandNow: "Condição agora",
    bandActivity: "Atividade",
    nearestIonosonde: "Ionosonda",
    activityFootnote: "Atividade: spots PSK Reporter num raio de 500 km, últimos 30 min",
    noIonosondeFallback: "Sem ionosonda próxima — mostrando panorama global",
    invalidGrid: "Grid inválido",
    searchingCity: "Buscando...",
    noCityResults: "Nenhuma cidade encontrada",
    temperature: "Temperatura",
    feelsLike: "Sensação",
    windSpeed: "Vento",
    windGust: "Rajada",
    humidity: "Umidade",
    pressureHpa: "Pressão",
    visibilityLabel: "Visibilidade",
    mastRisk: "Risco p/ Mastro de Antena",
    lightningRisk: "Risco de Raios",
    riskLow: "BAIXO",
    riskModerate: "MODERADO",
    riskHigh: "ALTO",
    riskExtreme: "EXTREMO",
    mastLow: "Operação segura, sem restrições.",
    mastModerate: "Estais necessários, limitar mastro a 6m.",
    mastHigh: "Recolher mastro. Ventos fortes.",
    mastExtreme: "NÃO montar mastro. Perigo!",
    lightLow: "Sem risco de raios.",
    lightModerate: "Possível atividade elétrica. Fique atento.",
    lightHigh: "Tempestades previstas - tenha um plano de desconexão.",
    lightExtreme: "Tempestade ativa! Desconecte equipamentos.",
    forecast12h: "Previsão Próximas 12 Horas",
    forecastDays: "Previsão Estendida",
    rainChance: "Chuva",
    lastUpdated: "Atualizado",
    condGood: "Bom",
    condFair: "Regular",
    condPoor: "Ruim",
    quietConditions: "Condições Tranquilas",
    unsettledConditions: "Condições Instáveis",
    stormConditions: "Tempestade Geomagnética",
    geomagQuiet: "Calmo",
    geomagUnsettled: "Instável",
    geomagStorm: "Tempestade",
    tipSolarFlux: "Fluxo de rádio solar em 10,7 cm. Mede a radiação que ioniza a camada F. Acima de 100 = boas condições em HF; acima de 150 = 10m e 15m abrem com frequência.",
    tipAIndex: "Média diária da atividade geomagnética (0 a 400). Até 7 = campo calmo e propagação estável; acima de 20 = absorção e sinais fracos, principalmente nas rotas polares.",
    tipKIndex: "Atividade geomagnética das últimas 3 horas (0 a 9). 0 a 2 = excelente; 4 ou mais indica tempestade, com blackout e ruído em HF.",
    tipSunspots: "Número de manchas solares visíveis. Mais manchas = mais ionização = bandas altas (10m, 12m, 15m) abertas para DX.",
    tipSignalNoise: "Nível estimado de ruído de fundo, em pontos S. S0 a S2 = banda silenciosa, ideal para sinais fracos; S5 ou mais dificulta copiar DX.",
    tipGeomagField: "Estado do campo magnético da Terra. Calmo favorece propagação estável; instável ou em tempestade traz aurora, fading e perda das rotas polares.",
    tipMuf: "Máxima frequência utilizável para um salto de 3000 km, medida pela ionosonda mais próxima. Opere abaixo dela: cerca de 80 a 90% da MUF costuma ser a melhor faixa para DX.",
    tipFof2: "Frequência crítica da camada F2, medida na vertical. É o limite para NVIS e contatos locais: abaixo dela o sinal retorna, acima ele escapa para o espaço.",
    fieldOps: "OPERAÇÃO EM CAMPO",
    upcomingThreats: "Alertas Próximas 12h",
    noThreats: "Sem alertas meteorológicos",

    // QSL Card Manager
    qslTitle: "QSL Card Manager",
    qslSelectQsos: "Selecionar QSOs",
    qslPreviewSend: "Preview & Envio",
    qslHistory: "Histórico",
    qslDesignStudioTab: "Design Studio",
    qslInboxTab: "Caixa de Entrada",
    qslCardStyle: "Estilo do cartão",
    qslClassicTemplates: "Modelos clássicos",
    qslInboxReceived: "QSLs Recebidos",
    qslInboxConfirmed: "Confirmados",
    qslInboxEmpty: "Nenhum QSL recebido ainda. Quando outro operador do HamExpert te enviar um QSL, ele aparece aqui.",
    qslInboxConfirm: "Confirmar QSO",
    qslDesignSaved: "Design salvo!",
    qslDesignSaveFirst: "Salve o design primeiro",
    qslDesignDefaultSet: "Definido como padrão",
    qslDesignDeleteConfirm: "Excluir este design?",
    qslDesignName: "Nome do design",
    qslDesignSave: "Salvar",
    qslDesignSaveAsNew: "Salvar como novo",
    qslDesignIsDefault: "Padrão",
    qslDesignSetDefault: "Definir como padrão",
    qslDesignDelete: "Excluir",
    qslDesignPresets: "Modelos",
    qslDesignAdd: "Adicionar",
    qslDesignText: "Texto",
    qslDesignField: "Campo QSO",
    qslDesignBox: "Caixa",
    qslDesignLine: "Linha",
    qslDesignLogo: "Logo/Imagem",
    qslDesignBg: "Fundo",
    qslDesignBgSolid: "Cor sólida",
    qslDesignBgGradient: "Gradiente",
    qslDesignBgImage: "Imagem",
    qslDesignUpload: "Enviar imagem",
    qslDesignBgChange: "Trocar imagem",
    qslDesignBgDarken: "Escurecer fundo",
    qslDesignBgRemove: "Remover imagem",
    qslDesignHint: "Arraste os elementos no cartão para posicioná-los.",
    qslDesignSelectHint: "Selecione um elemento no cartão para editar suas propriedades.",
    qslDesignDuplicate: "Duplicar",
    qslDesignFront: "Frente",
    qslDesignBack: "Trás",
    qslDesignTextContent: "Conteúdo do texto",
    qslDesignCaption: "Legenda (acima)",
    qslDesignSize: "Tamanho",
    qslDesignColor: "Cor",
    qslDesignAlign: "Alinhamento",
    qslDesignStyle: "Estilo",
    qslDesignFont: "Fonte",
    qslDesignGlow: "Brilho",
    qslDesignWidth: "Largura",
    qslDesignHeight: "Altura",
    qslDesignFill: "Preenchimento",
    qslDesignBorder: "Borda",
    qslDesignRadius: "Arredondamento",
    qslDesignThickness: "Espessura",
    qslDesignOpacity: "Opacidade",
    qslQueue: "Fila de Envio",
    qslSent: "QSLs Enviados",
    qslPendingToSend: "Pendente p/ Enviar",
    qslSearchCall: "Buscar indicativo...",
    qslAllBands: "Todas Bandas",
    qslAllModes: "Todos Modos",
    qslSelectPage: "Selecionar Página",
    qslSelectAll: "Selecionar Todos",
    qslClear: "Limpar",
    qslSelected: "selecionado(s)",
    qslChooseTemplate: "Escolher Template",
    qslPersonalMsg: "Mensagem pessoal (opcional)",
    qslClickPreview: "Clique num QSO para pré-visualizar",
    qslRecipientEmail: "Email do destinatário...",
    qslDownloadPng: "Download",
    qslSendEqsl: "Enviar eQSL",
    qslSending: "Enviando...",
    qslEmailInvalid: "Email inválido",
    qslNoQsoSelected: "Nenhum QSO selecionado. Vá em",
    qslFirst: "primeiro.",
    qslBatchTitle: "Envio em Lote — Fila de Email",
    qslBatchDesc: "Emails são enviados 1 a cada 90s para proteger a reputação do servidor.",
    qslDailyLimit: "Limite diário",
    qslDailyLimitReached: "Limite diário atingido. Tente novamente amanhã.",
    qslSentToday: "Enviados hoje",
    qslQueueBtn: "Enfileirar",
    qslQueueBtnSuffix: "QSLs para envio",
    qslPreparing: "Preparando",
    qslQueuing: "Enfileirando...",
    qslEstimatedTime: "Tempo estimado",
    qslQueueActive: "Fila Ativa — Enviando emails...",
    qslQueueComplete: "Fila Completa",
    qslNextEmail: "Próximo email em",
    qslRemaining: "Restante",
    qslDaily: "Diário",
    qslSentSection: "Enviados",
    qslPendingSection: "Pendentes",
    qslAwaitingLookup: "buscando email...",
    qslNoEmailFound: "Email Nao Encontrado",
    qslNoEmailDesc: "Estes indicativos não possuem email no HamQTH. Você pode enviar manualmente na aba Preview & Envio.",
    qslNoEmailHamqth: "Sem email no HamQTH",
    qslNoEmailTab: "Sem E-mail",
    qslNoEmailTabTitle: "QSOs sem e-mail encontrado",
    qslNoEmailTabDesc: "Estes QSOs foram removidos da fila de envio porque não encontramos o email no HamQTH/QRZ. Se você conseguir o email por outro meio, informe abaixo para reenfileirar o envio.",
    qslNoEmailEmpty: "Nenhum QSO sem email no momento",
    qslEnterEmailPlaceholder: "Informe o email manualmente...",
    qslRetryWithEmail: "Reenviar",
    qslDismiss: "Descartar",
    qslRetrySuccess: "QSL re-enfileirado!",
    qslDismissConfirm: "Descartar este QSO da lista sem email?",
    qslSendErrors: "Erros de Envio",
    qslUnknownError: "Erro desconhecido",
    qslCancelPending: "Cancelar Pendentes",
    qslNoHistory: "Nenhum QSL enviado ainda",
    qslStatusSent: "ENVIADO",
    qslStatusError: "ERRO",
    qslStatusPending: "PENDENTE",
    qslViewCard: "Ver QSL",
    qslHistoryTo: "PARA",
    qslHistoryEmail: "EMAIL",
    qslHistoryTemplate: "TEMPLATE",
    qslHistoryStatus: "STATUS",
    qslHistorySentAt: "ENVIADO EM",

    // Onboarding
    onboardingTitle: "Bem-vindo ao HamExpert!",
    onboardingSubtitle: "Conclua a verificação obrigatória — os demais passos são opcionais.",
    onboardingOptionalTag: "Opcional",
    onboardingRequiredTag: "Obrigatório",
    onboardingNextOptional: "Configurar opcionais",
    onboardingStep1Title: "Conectar LoTW",
    onboardingStep1Desc: "Importe seus QSOs confirmados do Logbook of The World. Se você usa LoTW, configure suas credenciais para sincronizar automaticamente.",
    onboardingStep2Title: "Conectar ao QRZ",
    onboardingStep2Desc: "Conecte seu QRZ Logbook e importe todo o seu histórico automaticamente.",
    onboardingStep3Title: "Dashboard QRZ",
    onboardingStep3Desc: "Copie o código iframe para exibir suas estatísticas no seu perfil do QRZ.com.",
    onboardingStep4Title: "Validar Licença",
    onbLicenseTitle: "Validar licença de rádio",
    onbLicenseDesc: "Envie uma foto ou digitalização da sua licença de radioamador. Nossa IA verifica se o indicativo confere com o documento e se a licença está válida — e você ganha o selo de operador verificado.",
    onbLicensePrivacy: "A imagem não é armazenada — é removida após a verificação.",
    onbLicenseSelect: "Enviar imagem da licença",
    onbLicenseVerifying: "Verificando licença com IA...",
    onbLicenseVerified: "Licença verificada!",
    onbLicenseFailTitle: "Não foi possível verificar automaticamente",
    onbLicenseReview: "Seu pedido foi enviado para revisão manual. Você pode tentar novamente com uma imagem mais nítida.",
    onbLicenseReasonNotLicense: "A imagem não parece ser uma licença de radioamador válida.",
    onbLicenseReasonMismatch: "O indicativo no documento não confere com o da sua conta.",
    onbLicenseReasonExpired: "A licença parece estar vencida.",
    onbLicenseReasonLowConf: "Não conseguimos ler o documento com confiança suficiente. Tente uma imagem mais nítida e bem iluminada.",
    profileLicenseTitle: "Licença de rádio",
    profileLicenseVerified: "Verificada",
    profileLicenseVerifiedDesc: "Sua licença de radioamador foi verificada. Você exibe o selo de operador verificado.",
    profileLicenseDesc: "Verifique sua licença para ganhar o selo de operador verificado.",
    profileLicenseVerify: "Verificar licença",
    onboardingSkip: "Pular este passo",
    onboardingNext: "Próximo",
    onboardingPrev: "Anterior",
    onboardingFinish: "Começar a usar!",
    onboardingSkipAll: "Pular configuração",
    onboardingStepComplete: "Configurado!",
    onboardingOptional: "(Opcional)",
    onboardingSelectFile: "Clique ou arraste um arquivo ADIF/Cabrillo aqui",
    onboardingLotwSaved: "Credenciais salvas! Sync automático ativado.",
    onboardingUploadDone: "logs carregados com sucesso!",
    onboardingCopied: "Copiado!",

    // Heraldo Home Card
    heraldoCardTitle: "Pergunte ao Heraldo",
    heraldoCardDesc: "Seu assistente de rádio com IA. Saiba como está a propagação, dicas de antena, melhores bandas e muito mais!",
    heraldoCardAsk: "Como está a propagação agora?",
    heraldoCardBand: "Melhor banda agora?",
    heraldoCardAntenna: "Dica de antena",
    heraldoCardDxcc: "Me ajude com DXCC"
  },
  en: {
    // General
    subtitle: "Advanced performance analysis for ham radio operators. Contest - DX - FT8",
    loading: "Loading...",
    errConnection: "Connection error",
    confirm: "Confirm",
    tip: "Tip",

    // Nav
    home: "Home", dashboard: "Dashboard", map: "Map", charts: "Charts",
    rankings: "Rankings", dxIntel: "AI Report", log: "Log", support: "Support",
    dxccNav: "DXCC",
    community: "Community", profile: "Profile", contests: "Contests", contestsNav: "Contest/Activation",
    uploadLogs: "Upload Logs",
    logout: "Logout",

    // Bug reports / tickets
    bugReport: "Report a Bug",
    integrations: "Integrations",
    integrationsTitle: "Integrations",
    integrationsSubtitle: "Connect HamExpert to your tools: LoTW, MSHV / WSJT-X and QRZ.com.",
    subscription: "Subscription",
    subTitle: "Choose your plan",
    subSubtitle: "Start free. Upgrade to Premium whenever you want to unlock integrations.",
    subLaunchBanner: "🎉 Launch offer: Premium is free for everyone for a limited time.",
    subCurrentPlan: "Your current plan",
    subCompareCol: "Compare plans",
    subPlanFreeName: "Free",
    subPlanFreePrice: "Free",
    subPlanFreeTag: "Forever",
    subPlanFreeDesc: "All analysis modules for your log.",
    subPlanPremiumName: "Premium",
    subPlanPremiumPrice: "R$ 6",
    subPlanPremiumPeriod: "/mo",
    subPlanPremiumTag: "Recurring card payment",
    subPlanPremiumDesc: "Everything in Free + full integrations.",
    subFeatAllModules: "All modules (Dashboard, Charts, DXCC, Rankings, Log, QSL Cards, Field Ops…)",
    subFeatCommunity: "Community and Live Streams",
    subFeatIaReport: "AI Report: smart AI analysis of your logs + personal assistant for your questions",
    subFeatIntegrations: "Integrations: LoTW, MSHV / WSJT-X, Log4OM / UDP",
    subFeatQrzDash: "Embeddable dashboard on your QRZ.com profile",
    subFeatPrioritySupport: "Priority support",
    subFeatNoIntegrations: "No integrations: LoTW, MSHV / WSJT-X, Log4OM / UDP",
    subFeatNoIaReport: "No AI Report module",
    subFeatNoQrzDash: "No QRZ.com dashboard",
    subBtnCurrent: "Current plan",
    subBtnSubscribe: "Subscribe to Premium",
    subBtnActiveLaunch: "✓ Premium active (launch)",
    subRecurringNote: "R$ 6.00 charged monthly to your credit card. Cancel anytime.",
    subIncluded: "Included",
    subNotIncluded: "Not included",
    premiumLockTitle: "Premium feature",
    premiumLockDesc: "Integrations are part of the Premium plan. Upgrade to connect LoTW, MSHV / WSJT-X, Log4OM and the QRZ.com dashboard.",
    premiumLockBtn: "View plans",
    log4omTab: "Log4OM / UDP",
    intHistoryTitle: "History (24h)",
    intHistoryTab: "History",
    intHistoryDesc: "Sync activity across all integrations in the last 24h.",
    refresh: "Refresh",
    intHistoryEmpty: "No activity in the last 24h",
    intHistColWhen: "When",
    intHistColSource: "Source",
    intHistColLoaded: "Loaded",
    intHistColStatus: "Status",
    intHistOk: "OK",
    intHistError: "Error",
    udpTitle: "UDP Reception",
    udpDesc: "Server service to receive QSOs from software like Log4OM, N1MM and GridTracker over UDP (ADIF forwarding).",
    udpRunning: "Server Running",
    udpStopped: "Server Stopped",
    udpManagedByAdmin: "Managed by Admin",
    udpConnAddress: "Connection Address",
    udpTip: "Configure your software to forward QSOs as ADIF to this address. Contacts are automatically attributed to your callsign (STATION_CALLSIGN field).",
    profileTitle: "My Profile",
    profileSubtitle: "Set up your ham radio profile",
    ptabInfo: "Information",
    ptabStation: "Station",
    ptabLinks: "Links",
    ptabImages: "Images",
    ptabAccount: "Account",
    personalInfo: "Personal Information",
    profilePhotoTitle: "Profile Photo",
    profilePhotoHint: "Click the camera to change",
    nameLabel: "Name",
    callsignField: "Callsign",
    countryLabel: "Country",
    qthLabel: "QTH",
    saveProfile: "Save Profile",
    stationTitle: "Equipment & Station",
    linksTitle: "Links & Social Media",
    imagesTitle: "Profile Image",
    livestreams: "Live Streams",
    livestreamsTitle: "Active Live Streams",
    livestreamsSubtitle: "DX stations broadcasting live right now — hunt the important contacts.",
    livestreamsSearch: "Search callsign/country",
    livestreamsSortRank: "By DXCC Rank",
    livestreamsSortTime: "By Time",
    livestreamsLoading: "Loading live streams...",
    livestreamsEmpty: "No active streams right now",
    livestreamsColCall: "Callsign",
    livestreamsColLocation: "Location",
    livestreamsColRank: "Rank",
    livestreamsColLast: "Last QSO",
    livestreamsColWatchers: "Watching",
    livestreamsWatch: "Watch",
    livestreamsCredit: "Data provided by Club Log (clublog.org). Auto-refreshes every 30s.",
    bugReportTitle: "Report a Bug",
    bugReportSubtitle: "Found a problem? Open a ticket and help us improve HamExpert.",
    newTicket: "New Ticket",
    noTickets: "No tickets",
    noTicketsHint: "You haven't reported any issues yet. Click \u201cNew Ticket\u201d to get started.",
    colMenu: "Menu",
    colTab: "Tab",
    colDescription: "Description",
    colStatus: "Status",
    colActions: "Actions",
    colDate: "Date",
    ticketMenu: "Menu",
    ticketTab: "Tab",
    ticketMenuPlaceholder: "e.g. Dashboard, Rankings, QSL Cards…",
    ticketTabPlaceholder: "e.g. Contact Map (optional)",
    ticketDescription: "Problem description",
    ticketDescriptionPlaceholder: "Describe what happened, what you expected, and how to reproduce it…",
    sendTicket: "Submit Ticket",
    cancel: "Cancel",
    ticketSent: "Ticket submitted successfully!",
    ticketError: "Error submitting ticket.",
    descRequired: "Please describe the problem.",
    deleteTicketConfirm: "Remove this ticket?",
    statusOpen: "Open",
    statusInProgress: "In progress",
    statusResolved: "Resolved",
    statusClosed: "Closed",
    attachScreenshot: "Attach screenshot (optional)",
    addImage: "Add image",
    removeImage: "Remove",
    viewScreenshot: "View screenshot",
    imageInvalid: "Please select an image file.",
    imageTooBig: "Image too large (max 6MB).",
    colImage: "Screenshot",
    // Bug report v1.0.5
    ticketType: "Type",
    ticketTypeBug: "Bug",
    ticketTypeSuggestion: "Suggestion",
    ticketTypeQuestion: "Question",
    ticketSeverity: "Severity",
    sevLow: "Low",
    sevMedium: "Medium",
    sevHigh: "High",
    sevCritical: "Critical",
    ticketWhatHappened: "What happened?",
    ticketWhatHappenedPh: "Describe the problem you ran into…",
    ticketExpected: "What did you expect?",
    ticketExpectedPh: "What should have happened (optional)…",
    ticketSteps: "Steps to reproduce",
    ticketStepsPh: "1. Opened… 2. Clicked… 3. Got… (optional)",
    ticketContext: "Automatically captured context",
    ticketContextPage: "Page",
    ticketContextVersion: "Version",
    ticketContextDevice: "Device",
    attachScreenshots: "Attach screenshots (up to 5)",
    colType: "Type",
    filterAll: "All",
    ticketDetail: "Ticket details",
    ticketConversation: "Conversation",
    ticketNoReplies: "No messages yet. Write below to talk to the team.",
    ticketReplyPh: "Write a message…",
    ticketSendReply: "Send",
    ticketReplyEmpty: "Write a message.",
    ticketYou: "You",
    ticketTeam: "HamExpert Team",
    ticketNewUpdate: "New reply from the team",
    ticketBack: "Back",
    ticketOpenDetail: "Open",

    // Auth
    login: "Sign In",
    createAccount: "Create Account",
    backToLogin: "Back to login",
    recoverPassword: "Recover Password",
    recoverPasswordDesc: "We will send a link to your registered email",
    passwordLabel: "PASSWORD",
    confirmPasswordLabel: "CONFIRM PASSWORD",
    yourCallsign: "YOUR CALLSIGN",
    verifying: "Verifying...",
    creatingAccount: "Creating account...",
    sending: "Sending...",
    sendRecoveryLink: "Send Recovery Link",
    forgotPassword: "Forgot my password",
    loginIntro: "Analyze your QSOs with intelligence. Statistics, maps, DX and much more.",
    callsignPh: "Ex: PP5GP",
    yourPassword: "Your password",
    minChars: "Minimum 8 characters",
    repeatPassword: "Repeat password",
    yourCallsignPh: "Your callsign",
    yourEmail: "your@email.com",

    // Auth errors
    errFillCallPass: "Fill in callsign and password.",
    errFillAll: "Fill in all fields.",
    errPassMismatch: "Passwords don't match.",
    errPassMin: "Minimum password: 8 characters.",
    accountCreated: "Account created! Sign in, ",
    errFillAllFields: "Fill in all fields.",
    errPassMismatchShort: "Passwords don't match.",
    errPassMin8: "Minimum 8 characters.",
    passChanged: "Password changed successfully!",
    errChangePass: "Error changing password",

    // Login features
    featureStats: "AI Intelligence",
    featureStatsSub: "AI-powered stats that learn from your log",
    featureMap: "QRZ Dashboard",
    featureMapSub: "Embed on QRZ and share your performance",
    featureIncremental: "SOTA, POTA & Contests",
    featureIncrementalSub: "Incremental upload with LoTW sync",
    developedBy: "Developed by",

    // Upload / Home
    dragHere: "Drag your log here",
    orClick: "or click to select",
    myGrid: "My Grid:",
    detectedAuto: "Automatically detected:",
    processing: "Processing log...",
    qsosLoaded: "QSOs loaded!",
    whatToDo: "What would you like to do?",
    logBook: "Logbook",
    logBookDesc: "Upload your ADIF to the logbook. Incremental upload — only new QSOs.",
    contestEvent: "Contest / Event",
    contestEventDesc: "Isolated analysis of contests, Field Day, special activations.",
    contestNameLabel: "Name:",
    contestNamePh: "Ex: CQ WPX 2026, Field Day",
    contestNameRequired: "Enter the contest/event name before uploading the log",
    loadingServerQsos: "Loading saved QSOs from server...",
    formatNotRecognized: "Format not recognized. Use ADIF or Cabrillo.",
    noQsoFound: "No QSO found.",
    savedOnServer: "QSOs saved on server",
    dupsRemoved: "dups removed",

    // Dashboard
    totalQsos: "Total QSOs", uniqueCalls: "Unique Calls", countriesDxcc: "DXCC Countries",
    uniqueGrids: "Unique Grids", maxDistance: "Max Distance", avgDistance: "Avg Distance",
    logPeriod: "Log Period", qsoPerHour: "QSO/Hour Avg", bestHour: "Best Hour",
    bestBand: "Best Band", topBandDay: "Top Band Day", topBandNight: "Top Band Night",
    days: "days", daysOfLog: "days of log", qsosInBestBand: "QSOs in best band",
    qsosByHourUtc: "Average QSOs per Hour", qsosByBand: "QSOs by Band", qsosByMode: "QSOs by Mode",
    qsosByContinent: "QSOs by Continent", detailedByBand: "Average QSOs per Hour - Detailed by Band",
    allBands: "All", top10Countries: "Top 10 DXCC Countries",
    dateAll: "All",
    dateTo: "to",
    mediaPerDay: "Avg",
    qsosPerDay: "QSOs/day",
    totalLabel: "Total",
    daysLabel: "days",

    // Map
    withGrid: "With Grid", withoutGrid: "No Grid", countries: "Countries", fullMap: "Full Map",
    mapTitle: "QSO Map", mapGridTitle: "Contacted Grids Map", qsosWithCoords: "QSOs with coordinates",
    mapLabel: "Map",
    // DXCC Tracker
    dxAwardsNav: "DX Awards",
    dxccTitle: "DXCC Tracker", dxccWorked: "Worked", dxccConfirmed: "Confirmed", dxccNeeded: "Needed",
    dxccByBand: "By Band", dxccByMode: "By Mode", dxccAll: "All", dxccFilterCont: "Continent",
    dxccEntity: "Entity", dxccTotal: "Total",
    // WAC / WAZ
    wacTitle: "WAC - All Continents", wazTitle: "WAZ - All CQ Zones",
    zonesWorked: "zones worked", zonesConfirmed: "confirmed",
    // New One Alerts
    newDxcc: "New DXCC!", newBandSlot: "New Band!", newGrid: "New Grid!", showNewOnly: "New only", newOneAlerts: "New One Alerts",
    // Heraldo
    heraldoPlaceholder: "Ask anything about ham radio...", heraldoError: "Error connecting to Heraldo. Try again.",
    // Callsign Lookup
    callsignLookup: "Callsign Lookup", searchAll: "Search", notFound: "Not found", notInFcc: "Not found in FCC database",

    // Charts
    chartsTitle: "Interactive Charts",
    qsoRateByHour: "QSO Rate by Hour", qsosOverTime: "QSOs Over Time",
    distributionByMode: "Distribution by Mode",

    // Rankings
    rankingsTitle: "Rankings & Statistics",
    rankingDxcc: "DXCC Ranking - Countries", rankingBands: "Band Ranking",
    rankingModes: "Mode Ranking", rankingContinents: "Continent Ranking",
    rankingHours: "Hour Ranking", rankingCqZones: "CQ Zone Ranking",

    // IA Report
    dxIntelTitle: "AI Report",
    recommendations: "Recommendations Based on Your Logs",
    activityByBand: "Average Activity by Band x Hour (24h)",
    bestBandByPeriod: "Best Band by Period (3h)",
    periodUtc: "Period", firstBand: "1st Band", secondBand: "2nd Band",
    avgDistByBand: "Avg Distance by Band", topContinentsByBand: "Top Continents by Band",
    dayOperation: "Day Operation",
    nightOperation: "Night Operation",
    confLabel: "Conf.",
    confInsufficient: "Insufficient data",
    confLow: "Low confidence",
    confMedium: "Medium confidence",
    confHigh: "High confidence",
    confInfo: "Info",

    // DX Intel recommendations
    recBestTime: "Your best time is {slot} with {total} QSOs. Focus operation in this period.",
    recBestDist: "Band {band} has the highest avg distance ({dist} km). Ideal for long DX.",
    recDayNight: "During day use {day}, at night switch to {night} to maximize QSOs.",
    recNightWindow: "Best night window: {slot} ({band} with {qsos} QSOs).",

    // Log page
    logTitle: "Log",
    filterPlaceholder: "Filter call, country, band, mode...",
    showing: "Showing", of: "of",
    exportAdif: "Export ADIF", exportAll: "Export All",
    allBandsFilter: "All bands", allModesFilter: "All modes", dateFromLabel: "From", dateToLabel: "To",
    prevPage: "Prev", nextPage: "Next", pageOf: "of",

    // Support / Coffee
    supportTitle: "Support the HamExpert Project", buyMeACoffee: "Buy Me a Coffee",
    coffeeText: "If HamExpert helped you analyze your logs and improve your performance, consider buying me a coffee! Every contribution helps keep the project active.",
    whatYouSupport: "What your contribution supports",
    supportItems: ["Server and hosting","New features","Updated DXCC database","New log formats","AI Report improvements","Coffee for PP5GP in contests!"],
    bioText: "Class A ham radio operator (PP5GP), operating from Brusque, SC, Brazil. Passionate about electronics and fascinated by the world of radio frequency. IT professional with over 15 years of experience in infrastructure, automation, cloud computing and DevOps. Creator of HamExpert.",
    footer: "HamExpert v1.2.2 - hamexpert.cloud - Developed by PP5GP - Geraldo Lucas Poli - 73!",
    supportersTitle: "Project Supporters",
    supportersFalcons: "Friends above all",
    supportersFalconsDesc: "A group of ham radio friends who support and use HamExpert",

    // Contests
    myContests: "My Contests",
    contestSaved: "saved",
    contestsSaved: "saved",
    noContestSaved: "No contest saved",
    noContestDesc: "Upload a log in Contest mode on the home screen to analyze contest performance separately.",
    goToContestUpload: "Go to Contest Upload",
    analyzePerformance: "Analyze Performance",
    fileLabel: "File",

    // Profile
    accountData: "Account Data",
    totalLogins: "Total Logins",
    memberSince: "Member since",
    changePassword: "Change Password",
    currentPassword: "Current password",
    newPassword: "New password",
    confirmNew: "Confirm new",
    saveNewPassword: "Save New Password",
    publicProfile: "My Public Profile",
    publicProfileDesc: "Set up your profile to be found by the community.",
    loadProfile: "Load Profile",
    fullName: "Full name",
    licenseClass: "License class",
    licenseClassPh: "Ex: Class A",
    bioAbout: "Bio / About me",
    bioPlaceholder: "Tell about yourself and your station...",
    cityLabel: "City",
    stateLabel: "State",
    statePh: "Ex: SC",
    gridLocator: "Grid Locator",
    gridLocatorPh: "Ex: GG54mc",
    equipmentLabel: "Equipment",
    equipmentPh: "Ex: Yaesu FTDX10",
    antennaLabel: "Antenna",
    antennaPh: "Ex: Hexbeam",
    powerLabel: "Power",
    powerPh: "Ex: 100W",
    profilePhoto: "Profile photo",
    sendPhoto: "Upload Photo",
    removePhoto: "Remove Photo",
    fileTooLarge: "File too large (max 5MB)",
    photoUpdated: "Photo updated successfully!",
    removeProfilePhotoConfirm: "Remove profile photo?",
    savePublicProfile: "Save Public Profile",

    // LoTW
    lotwIntegration: "LoTW - Import QSOs",
    lotwDesc: "Pull your confirmed QSOs from LoTW into HamExpert. Read-only — no data is sent to LoTW.",
    checkLotwStatus: "Check LoTW Status",
    lotwLoginPh: "LoTW Login (callsign)",
    lotwPassPh: "LoTW Password",
    fillLoginPass: "Fill in login and password",
    saving: "Saving...",
    saveLotwCred: "Save LoTW Credentials",
    syncLabel: "Sync",
    active1h: "ACTIVE (1h)",
    disabledLabel: "DISABLED",
    lastSync: "Last sync",
    never: "Never",
    qsosViaLotw: "QSOs via LoTW",
    errorLabel: "Error",
    syncNow: "Sync Now",
    fullSync: "Full Re-sync",
    fullSyncHint: "Reprocesses the full LoTW history to refresh official DXCC entities. Use if your DXCC country count differs from LoTW.",
    fullSyncOk: "Full re-sync complete. Confirmed:",
    syncing: "Syncing...",
    disableSync: "Disable Sync",
    enableSync: "Enable Sync",
    removeLotwCredConfirm: "Remove LoTW credentials?",
    removeLabel: "Remove",
    credRemoved: "Credentials removed",
    syncOk: "Sync OK!",
    newQsos: "new QSOs",

    // QRZ Logbook import
    qrzImportTitle: "QRZ Logbook — Import QSOs",
    qrzImportDesc: "Automatically sync your QRZ.com logbook into HamExpert via the official QRZ Logbook API. Incremental import: only fetches new QSOs and marks those already confirmed on QRZ as confirmed.",
    qrzApiKeyPh: "Logbook API Key (QRZ)",
    qrzApiKeyHint: "Find it at QRZ.com → Logbook → Settings → \"API Access\". Requires a QRZ XML subscription.",
    saveQrzKey: "Validate & Save Key",
    qrzImportBtn: "Connect & Import from QRZ",
    qrzImporting: "Importing from QRZ...",
    onboardingOr: "or",
    validating: "Validating...",
    qrzBook: "Logbook",
    qrzBookCount: "QSOs on QRZ",
    qsosViaQrz: "QSOs imported from QRZ",
    removeQrzKeyConfirm: "Remove the QRZ API key?",
    qrzKeyRemoved: "QRZ key removed",
    qrzKeySaved: "Key validated and saved!",
    fillQrzKey: "Enter your QRZ API key",
    qrzFullResync: "Reimport everything",
    qrzFullResyncConfirm: "Reimport the ENTIRE QRZ history from scratch? It's safe (no duplicates), but may take a while for a large log.",

    // QRZ Embed
    qrzCode: "Code for QRZ.com",
    qrzDesc: "Paste this HTML code in your QRZ.com profile bio to display your statistics.",
    publicLink: "Public link",
    htmlCode: "HTML Code (iframe)",
    copyIframe: "Copy Iframe",
    copied: "Copied!",
    copyBadge: "Copy Badge",
    qrzTip: "If QRZ doesn't accept iframe, use the Badge which works on any website.",

    // Session
    sessionLabel: "Session",
    logoutAccount: "Sign Out",

    // Community
    communityTitle: "HamExpert Community",
    commTabOperators: "Operators",
    commTabForum: "Forum",
    delete: "Delete",
    fcat_general: "General",
    fcat_dx: "DX & Expeditions",
    fcat_equipment: "Equipment",
    fcat_contest: "Contests",
    fcat_help: "Help",
    fcat_news: "News",
    forumAll: "All",
    forumNewTopic: "New topic",
    forumEmptyTitle: "No topics yet",
    forumEmptyDesc: "Be the first to start a conversation in the community.",
    forumRepliesShort: "replies",
    forumReplies: "replies",
    forumNoReplies: "No replies yet. Be the first to reply!",
    forumReplyPlaceholder: "Write your reply...",
    forumSendReply: "Reply",
    forumLoginToReply: "Sign in to join the conversation.",
    forumBackToList: "Back to topics",
    forumNotFound: "Topic not found.",
    forumCategory: "Category",
    forumTitleLabel: "Title",
    forumTitlePlaceholder: "Summarize your topic",
    forumBodyLabel: "Message",
    forumBodyPlaceholder: "Share your question, experience or news...",
    forumPublish: "Publish",
    forumDeleteConfirm: "Delete this topic and all replies?",
    docs: "Documentation",
    docsTitle: "Documentation",
    docsNewArticle: "New article",
    docsEditArticle: "Edit article",
    docsEmptyShort: "No articles",
    docsEmptyTitle: "No articles yet",
    docsEmptyAdmin: "Create the first article by clicking \"New article\".",
    docsEmptyUser: "Documentation is still being prepared.",
    docsUpdated: "Updated",
    docsCategory: "Category",
    docsArticleTitle: "Title",
    docsContent: "Content",
    docsMarkdownHint: "(supports markdown)",
    docsDeleteConfirm: "Delete this article?",
    edit: "Edit",
    save: "Save",
    searchPlaceholder: "Search by callsign, name or city...",
    searchBtn: "Search",
    noResults: "No results found",
    loadMembers: "Load Community Members",
    loadingMembers: "Loading members...",
    back: "Back",
    bandsLabel: "Bands",
    stationLabel: "Station",
    linksLabel: "Links",
    memberSinceLabel: "Member since",
    editProfile: "Edit profile",
    classLabel: "Class",
    kpiTotalQsos: "Logged QSOs",
    kpiUniqueCalls: "Callsigns",
    kpiGrids: "Grids",

    // Realtime
    realtime: "Realtime",
    realtimeTitle: "Realtime Propagation",
    realtimeDesc: "Live FT8/FT4 spots via PSKReporter",
    bestBandNow: "Best Band Now",
    activeSpots: "Active Spots",
    activeBands: "Active Bands",
    activeGrids: "Active Grids",
    lastUpdateRt: "Last Update",
    autoRefresh: "Auto Refresh",
    spotCount: "Spots",
    avgSnr: "Avg SNR",
    avgDistRt: "Avg Distance",
    recommendationRt: "Recommendation",
    bandScore: "Score",
    realtimeMap: "Propagation Map",
    spotsTable: "Spots Table",
    sender: "Sender",
    receiver: "Receiver",
    frequencyRt: "Frequency",
    noSpotsYet: "Waiting for PSKReporter spots... Updates every 5 minutes.",
    bestBandExplain: "Based on spots from the last 15 min, {band} on {mode} has the best propagation right now for your location.",
    allModes: "All",
    filterBand: "Filter Band",
    filterMode: "Filter Mode",
    minSnr: "Min SNR",
    allSnr: "All",
    totalCached: "Total Cached",
    snrLabel: "SNR",
    distLabel: "Distance",
    timeLabel: "Time",
    bandActivity: "Band Activity",
    refreshNow: "Refresh Now",
    propagationScore: "Propagation Score",
    spotsLast15: "spots in last 15 min",
    bestForDx: "Best for DX",
    bestForRegional: "Best for Regional",
    noBandData: "No band data yet",

    // AI Analysis
    aiAnalysis: "AI Analysis",
    aiGenerateBtn: "Generate AI Analysis",
    aiGenerating: "Analyzing your data with AI...",
    aiPoweredBy: "AI-powered analysis",
    aiCached: "Cached analysis (updates every 5 min)",
    aiError: "Error generating analysis. Try again.",
    aiTitle: "Smart Log Analysis",
    saveEmail: "Save Email",
    emailUpdated: "Email updated successfully!",
    errInvalidEmail: "Invalid email. Use a real email (e.g. name@gmail.com).",
    bioHtmlTip: "Supports HTML: <h2>, <b>, <img src=\"...\">, <a href=\"...\">, <p>, <ul>, <li>, <blockquote>",
    topOperators: "Top HamExpert Operators",
    realtimeUpload: "Realtime Upload (MSHV / WSJT-X)",
    realtimeUploadDesc: "Receive QSOs automatically from MSHV, WSJT-X or any software that supports HTTP/ADIF upload.",
    generateApiKey: "Generate API Key",
    mshvConfig: "MSHV / WSJT-X Configuration",
    mshvInstructions: "In MSHV: Network Settings > Upload QSOs in Real Time. Paste the server and post path above. Every QSO will be sent automatically to HamExpert.",

    // Register Log / Manual QSO
    registerLog: "Register Log",
    manualQso: "Manual QSO Entry",
    manualQsoDesc: "Manually register a QSO by filling in the fields below.",
    callsignLabel: "Callsign",
    dateLabel: "Date",
    timeUtcLabel: "Time UTC",
    nowBtn: "Now",
    bandLabel: "Band",
    modeLabel: "Mode",
    rstSentLabel: "RST Sent",
    rstRcvdLabel: "RST Received",
    freqLabel: "Frequency",
    powerLabelQso: "Power",
    gridLabel: "Grid",
    notesLabel: "Notes",
    commentsLabel: "Comments",
    moreDetails: "+ Details",
    lessDetails: "- Details",
    saveQso: "Save QSO",
    savingQso: "Saving...",
    qsoSaved: "QSO saved successfully!",
    qsoSaveError: "Error saving QSO",
    fillCallsign: "Fill in the callsign",
    uploadFile: "File Upload",
    uploadFileDesc: "Upload your ADIF or Cabrillo file to the logbook or contest.",

    // Field Ops - Weather & Propagation
    fieldops: "Field Ops",
    fieldopsTitle: "Weather & Propagation",
    solarPropagation: "Solar Propagation",
    solarFlux: "Solar Flux (SFI)",
    aIndex: "A-Index",
    kIndex: "K-Index",
    sunspots: "Sunspots",
    signalNoise: "Noise",
    geomagField: "Geomag Field",
    bandConditions: "Band Conditions",
    bandDay: "Day",
    bandNight: "Night",
    fieldOpsWeather: "Field Operations Weather & Safety",
    fieldOpsDesc: "Local weather conditions for portable and field-day amateur radio operations.",
    fieldopsLocation: "Operation location",
    fieldopsLocHint: "Pick where you'll operate (POTA/SOTA/Field Day): click or drag the pin, type the grid, or search a city.",
    searchCity: "Search city...",
    enterGrid: "Grid (e.g. GI06)",
    useMyQth: "My QTH",
    changeLocation: "Change",
    closeLocation: "Close",
    useGps: "GPS",
    useGpsHint: "Use my position",
    gpsError: "Could not get your position",
    localBandConditions: "Band conditions at your location",
    bandNow: "Condition now",
    bandActivity: "Activity",
    nearestIonosonde: "Ionosonde",
    activityFootnote: "Activity: PSK Reporter spots within 500 km, last 30 min",
    noIonosondeFallback: "No ionosonde nearby — showing global outlook",
    invalidGrid: "Invalid grid",
    searchingCity: "Searching...",
    noCityResults: "No city found",
    temperature: "Temperature",
    feelsLike: "Feels like",
    windSpeed: "Wind",
    windGust: "Gust",
    humidity: "Humidity",
    pressureHpa: "Pressure",
    visibilityLabel: "Visibility",
    mastRisk: "Antenna Mast Risk",
    lightningRisk: "Lightning Risk",
    riskLow: "LOW",
    riskModerate: "MODERATE",
    riskHigh: "HIGH",
    riskExtreme: "EXTREME",
    mastLow: "Safe operation, no restrictions.",
    mastModerate: "Guy wires required, limit mast height to 20ft.",
    mastHigh: "Take down mast. Strong winds.",
    mastExtreme: "DO NOT erect mast. Danger!",
    lightLow: "No lightning risk.",
    lightModerate: "Possible electrical activity. Stay alert.",
    lightHigh: "Thunderstorms expected - have a disconnect plan ready.",
    lightExtreme: "Active thunderstorm! Disconnect equipment.",
    forecast12h: "12-Hour Field Ops Forecast",
    forecastDays: "Extended Forecast",
    rainChance: "Rain",
    lastUpdated: "Updated",
    condGood: "Good",
    condFair: "Fair",
    condPoor: "Poor",
    quietConditions: "Quiet Conditions",
    unsettledConditions: "Unsettled Conditions",
    stormConditions: "Geomagnetic Storm",
    geomagQuiet: "Quiet",
    geomagUnsettled: "Unsettled",
    geomagStorm: "Storm",
    tipSolarFlux: "10.7 cm solar radio flux. Measures the radiation that ionises the F layer. Above 100 = good HF conditions; above 150 = 10m and 15m open often.",
    tipAIndex: "Daily average of geomagnetic activity (0 to 400). Up to 7 = quiet field and stable propagation; above 20 = absorption and weak signals, especially on polar paths.",
    tipKIndex: "Geomagnetic activity over the last 3 hours (0 to 9). 0 to 2 = excellent; 4 or more means a storm, with HF blackouts and noise.",
    tipSunspots: "Count of visible sunspots. More spots = more ionisation = high bands (10m, 12m, 15m) open for DX.",
    tipSignalNoise: "Estimated background noise level, in S-units. S0 to S2 = quiet band, ideal for weak signals; S5 or more makes DX hard to copy.",
    tipGeomagField: "State of the Earth's magnetic field. Quiet favours stable propagation; unsettled or storm brings aurora, fading and loss of polar paths.",
    tipMuf: "Maximum usable frequency for a 3000 km hop, from the nearest ionosonde. Work below it: about 80 to 90% of the MUF is usually the best DX range.",
    tipFof2: "F2 layer critical frequency, measured vertically. It is the limit for NVIS and local contacts: below it the signal returns, above it escapes into space.",
    fieldOps: "FIELD OPS",
    upcomingThreats: "Upcoming Threats (next 12h)",
    noThreats: "No weather threats",

    // QSL Card Manager
    qslTitle: "QSL Card Manager",
    qslSelectQsos: "Select QSOs",
    qslPreviewSend: "Preview & Send",
    qslHistory: "History",
    qslDesignStudioTab: "Design Studio",
    qslInboxTab: "Inbox",
    qslCardStyle: "Card style",
    qslClassicTemplates: "Classic templates",
    qslInboxReceived: "QSLs Received",
    qslInboxConfirmed: "Confirmed",
    qslInboxEmpty: "No QSLs received yet. When another HamExpert operator sends you a QSL, it shows up here.",
    qslInboxConfirm: "Confirm QSO",
    qslDesignSaved: "Design saved!",
    qslDesignSaveFirst: "Save the design first",
    qslDesignDefaultSet: "Set as default",
    qslDesignDeleteConfirm: "Delete this design?",
    qslDesignName: "Design name",
    qslDesignSave: "Save",
    qslDesignSaveAsNew: "Save as new",
    qslDesignIsDefault: "Default",
    qslDesignSetDefault: "Set as default",
    qslDesignDelete: "Delete",
    qslDesignPresets: "Presets",
    qslDesignAdd: "Add",
    qslDesignText: "Text",
    qslDesignField: "QSO Field",
    qslDesignBox: "Box",
    qslDesignLine: "Line",
    qslDesignLogo: "Logo/Image",
    qslDesignBg: "Background",
    qslDesignBgSolid: "Solid color",
    qslDesignBgGradient: "Gradient",
    qslDesignBgImage: "Image",
    qslDesignUpload: "Upload image",
    qslDesignBgChange: "Change image",
    qslDesignBgDarken: "Darken background",
    qslDesignBgRemove: "Remove image",
    qslDesignHint: "Drag elements on the card to position them.",
    qslDesignSelectHint: "Select an element on the card to edit its properties.",
    qslDesignDuplicate: "Duplicate",
    qslDesignFront: "Front",
    qslDesignBack: "Back",
    qslDesignTextContent: "Text content",
    qslDesignCaption: "Caption (above)",
    qslDesignSize: "Size",
    qslDesignColor: "Color",
    qslDesignAlign: "Align",
    qslDesignStyle: "Style",
    qslDesignFont: "Font",
    qslDesignGlow: "Glow",
    qslDesignWidth: "Width",
    qslDesignHeight: "Height",
    qslDesignFill: "Fill",
    qslDesignBorder: "Border",
    qslDesignRadius: "Corner radius",
    qslDesignThickness: "Thickness",
    qslDesignOpacity: "Opacity",
    qslQueue: "Send Queue",
    qslSent: "QSLs Sent",
    qslPendingToSend: "Pending to Send",
    qslSearchCall: "Search callsign...",
    qslAllBands: "All Bands",
    qslAllModes: "All Modes",
    qslSelectPage: "Select Page",
    qslSelectAll: "Select All",
    qslClear: "Clear",
    qslSelected: "selected",
    qslChooseTemplate: "Choose Template",
    qslPersonalMsg: "Personal message (optional)",
    qslClickPreview: "Click a QSO to preview the card",
    qslRecipientEmail: "Recipient email...",
    qslDownloadPng: "Download",
    qslSendEqsl: "Send eQSL",
    qslSending: "Sending...",
    qslEmailInvalid: "Invalid email",
    qslNoQsoSelected: "No QSOs selected. Go to",
    qslFirst: "first.",
    qslBatchTitle: "Batch Send — Email Queue",
    qslBatchDesc: "Emails are sent 1 every 90s to protect server reputation.",
    qslDailyLimit: "Daily limit",
    qslDailyLimitReached: "Daily limit reached. Try again tomorrow.",
    qslSentToday: "Sent today",
    qslQueueBtn: "Queue",
    qslQueueBtnSuffix: "QSLs for sending",
    qslPreparing: "Preparing",
    qslQueuing: "Queuing...",
    qslEstimatedTime: "Estimated time",
    qslQueueActive: "Queue Active — Sending emails...",
    qslQueueComplete: "Queue Complete",
    qslNextEmail: "Next email in",
    qslRemaining: "Remaining",
    qslDaily: "Daily",
    qslSentSection: "Sent",
    qslPendingSection: "Pending",
    qslAwaitingLookup: "awaiting lookup...",
    qslNoEmailFound: "No Email Found",
    qslNoEmailDesc: "These callsigns have no email registered on HamQTH. You can send them manually from the Preview & Send tab.",
    qslNoEmailHamqth: "No email on HamQTH",
    qslNoEmailTab: "No Email",
    qslNoEmailTabTitle: "QSOs without email",
    qslNoEmailTabDesc: "These QSOs were removed from the send queue because we could not find an email on HamQTH/QRZ. If you obtain the email through another source, enter it below to re-queue the send.",
    qslNoEmailEmpty: "No QSOs without email at the moment",
    qslEnterEmailPlaceholder: "Enter email manually...",
    qslRetryWithEmail: "Retry Send",
    qslDismiss: "Dismiss",
    qslRetrySuccess: "QSL re-queued!",
    qslDismissConfirm: "Dismiss this QSO from the no-email list?",
    qslSendErrors: "Send Errors",
    qslUnknownError: "Unknown error",
    qslCancelPending: "Cancel Pending",
    qslNoHistory: "No QSL cards sent yet",
    qslStatusSent: "SENT",
    qslStatusError: "ERROR",
    qslStatusPending: "PENDING",
    qslViewCard: "View QSL",
    qslHistoryTo: "TO",
    qslHistoryEmail: "EMAIL",
    qslHistoryTemplate: "TEMPLATE",
    qslHistoryStatus: "STATUS",
    qslHistorySentAt: "SENT AT",

    // Onboarding
    onboardingTitle: "Welcome to HamExpert!",
    onboardingSubtitle: "Complete the required verification — the other steps are optional.",
    onboardingOptionalTag: "Optional",
    onboardingRequiredTag: "Required",
    onboardingNextOptional: "Set up optional steps",
    onboardingStep1Title: "Connect LoTW",
    onboardingStep1Desc: "Import your confirmed QSOs from Logbook of The World. If you use LoTW, configure your credentials for automatic sync.",
    onboardingStep2Title: "Connect QRZ",
    onboardingStep2Desc: "Connect your QRZ Logbook and import your entire history automatically.",
    onboardingStep3Title: "QRZ Dashboard",
    onboardingStep3Desc: "Copy the iframe code to display your stats on your QRZ.com profile.",
    onboardingStep4Title: "Verify License",
    onbLicenseTitle: "Verify radio license",
    onbLicenseDesc: "Upload a photo or scan of your amateur radio license. Our AI checks whether the callsign matches the document and whether the license is valid — and you earn the verified operator badge.",
    onbLicensePrivacy: "The image is not stored — it is removed after verification.",
    onbLicenseSelect: "Upload license image",
    onbLicenseVerifying: "Verifying license with AI...",
    onbLicenseVerified: "License verified!",
    onbLicenseFailTitle: "Could not verify automatically",
    onbLicenseReview: "Your request was sent for manual review. You can try again with a clearer image.",
    onbLicenseReasonNotLicense: "The image doesn't appear to be a valid amateur radio license.",
    onbLicenseReasonMismatch: "The callsign on the document doesn't match your account.",
    onbLicenseReasonExpired: "The license appears to be expired.",
    onbLicenseReasonLowConf: "We couldn't read the document with enough confidence. Try a sharper, well-lit image.",
    profileLicenseTitle: "Radio license",
    profileLicenseVerified: "Verified",
    profileLicenseVerifiedDesc: "Your amateur radio license has been verified. You display the verified operator badge.",
    profileLicenseDesc: "Verify your license to earn the verified operator badge.",
    profileLicenseVerify: "Verify license",
    onboardingSkip: "Skip this step",
    onboardingNext: "Next",
    onboardingPrev: "Previous",
    onboardingFinish: "Start using!",
    onboardingSkipAll: "Skip setup",
    onboardingStepComplete: "Configured!",
    onboardingOptional: "(Optional)",
    onboardingSelectFile: "Click or drag an ADIF/Cabrillo file here",
    onboardingLotwSaved: "Credentials saved! Auto sync enabled.",
    onboardingUploadDone: "logs loaded successfully!",
    onboardingCopied: "Copied!",

    // Heraldo Home Card
    heraldoCardTitle: "Ask Heraldo",
    heraldoCardDesc: "Your AI-powered radio assistant. Get propagation info, antenna tips, best bands and more!",
    heraldoCardAsk: "How is propagation right now?",
    heraldoCardBand: "Best band right now?",
    heraldoCardAntenna: "Antenna tips",
    heraldoCardDxcc: "Help me with DXCC"
  }
};

export function detectLanguage(geoInfo) {
  // 1) Check browser language first (navigator.language / navigator.languages)
  try {
    var langs = navigator.languages || [navigator.language || ""];
    for (var li = 0; li < langs.length; li++) {
      var bl = (langs[li] || "").toLowerCase();
      if (bl.indexOf("pt") === 0) return "pt";
      if (bl.indexOf("en") === 0) return "en";
    }
  } catch(e) {}

  // 2) Fallback: check GeoIP country
  if (geoInfo && geoInfo.country) {
    var ptCountries = ["Brazil","Portugal","Angola","Mozambique","Cape Verde"];
    for (var i = 0; i < ptCountries.length; i++) {
      if (geoInfo.country.indexOf(ptCountries[i]) >= 0) return "pt";
    }
    return "en";
  }

  return "en";
}

export function t(lang, key) {
  var dict = translations[lang] || translations.pt;
  return dict[key] !== undefined ? dict[key] : (translations.pt[key] || key);
}
